import React from 'react';
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography,
  Box,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FIELD_STYLES } from './fieldStyles';

const CustomSelect = ({
  id,
  label,
  required = false,
  value,
  onChange,
  options = [],
  placeholder,
  error,
  helperText,
  disabled = false,
  renderOption,
  ...rest
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {label && (
        <Typography variant="body2" fontWeight={600}>
          {label}
          {required && (
            <Box component="span" sx={{ color: 'error.main', ml: 0.25 }}>
              *
            </Box>
          )}
        </Typography>
      )}

      <FormControl fullWidth error={!!error} disabled={disabled}>
        <Select
          id={id}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty={!!placeholder}
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            fontSize: FIELD_STYLES.fontSize,
            minHeight: FIELD_STYLES.minHeight,

            '& .MuiSelect-select': {
              padding: `${FIELD_STYLES.paddingY} ${FIELD_STYLES.paddingX} !important`,
              display: 'flex',
              alignItems: 'center',
            },
          }}
          {...rest}>
          {placeholder && (
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
          )}

          {options.map((opt) => (
            <MenuItem key={opt.id} value={opt.id} disabled={opt.disabled}>
              {renderOption ? renderOption(opt) : opt.name}
            </MenuItem>
          ))}
        </Select>

        {(error || helperText) && (
          <FormHelperText sx={{ m: 0 }}>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default CustomSelect;
